import React from 'react';
import { faUmbrellaBeach } from '@fortawesome/free-solid-svg-icons';
import { WidgetRow, WidgetFooter, WidgetEmpty, Pill, formatRange, useGoTo } from './common';

const MyLeaveWidget = ({ data }) => {
  const goTo = useGoTo();
  const pending = data.pending || [];
  const upcoming = data.upcoming || [];
  const balance = data.balance;
  return (
    <>
      {balance && (
        <div className="mydesk-balance">
          <div>
            <span className="mydesk-balance-value">{balance.available_days}</span>
            <span className="mydesk-balance-label">days left in {data.year}</span>
          </div>
          <div className="mydesk-balance-meta">
            <span>{balance.total_used} used</span>
            <span>{balance.total_pending} pending</span>
          </div>
        </div>
      )}
      {pending.length === 0 && upcoming.length === 0 && (
        <WidgetEmpty>No pending or upcoming leave.</WidgetEmpty>
      )}
      {pending.map((r) => (
        <WidgetRow
          key={`p-${r.id}`}
          icon={faUmbrellaBeach}
          tone="warn"
          title={formatRange(r.start_date, r.end_date)}
          subtitle={`${r.leave_type} · ${r.total_days} day${r.total_days === '1.0' ? '' : 's'}`}
          right={<Pill tone="pending">Pending</Pill>}
          onClick={() => goTo(data.url)}
        />
      ))}
      {upcoming.map((r) => (
        <WidgetRow
          key={`u-${r.id}`}
          icon={faUmbrellaBeach}
          tone="ok"
          title={formatRange(r.start_date, r.end_date)}
          subtitle={`${r.leave_type} · ${r.total_days} day${r.total_days === '1.0' ? '' : 's'}`}
          right={<Pill tone="ok">Approved</Pill>}
          onClick={() => goTo(data.url)}
        />
      ))}
      <WidgetFooter label="Open leave management" url={data.url} />
    </>
  );
};

export default MyLeaveWidget;
